<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: sun
 * @Date: 2022-04-26 14:26:03
-->
<template>
  <div class="home-container container">
    <header>
      <video
        src="http://1252627319.vod2.myqcloud.com/2b70b5b0vodtranscq1252627319/a1453cc6387702299734676548/v.f100020.mp4"
        controls
      ></video>
      <h1>
        地方绿色金融发展一方绿色金融发展一
      </h1>
      <p>
        <span class="name">中国人</span><span class="job">金融发金融发</span>
      </p>
    </header>
    <section>
      <h1>
        练习
      </h1>
      <p>
        <img
          src="https://nbd-luyan-1252627319.cos.ap-shanghai.myqcloud.com/nbd-console/a7dfccc97b52fcce718ecc1a4e8a4278.png"
          alt=""
        />
        <span>地方绿色金融发展基础课练习</span>
      </p>
    </section>
    <div class="courseTabs">
      <div class="tabBox">
        <div class="tabName">
          选集
        </div>
      </div>
      <div class="tabWarp">
        <div class="tabContent">
          <ul>
            <li>
              <div class="flex">
                <p class="no">01</p>
                <p class="course-title">
                  地方绿色金融发展一方绿色金融发展一方绿色金融发展一方绿色金融发展一分钟先导课
                  <small>04.25</small>
                </p>
              </div>
            </li>
            <li>
              <div class="flex">
                <p class="no">01</p>
                <p class="course-title">
                  地方绿色金融发展一方绿色金融发展一方绿色金融发展一方绿色金融发展一分钟先导课
                  <small>04.25</small>
                </p>
              </div>
            </li>
            <li>
              <div class="flex">
                <p class="no">01</p>
                <p class="course-title">
                  地方绿色金融发展一方绿色金融发展一方绿色金融发展一方绿色金融发展一分钟先导课
                  <small>04.25</small>
                </p>
              </div>
            </li>
            <li>
              <div class="flex">
                <p class="no">01</p>
                <p class="course-title">
                  地方绿色金融发展一方绿色金融发展一方绿色金融发展一方绿色金融发展一分钟先导课
                  <small>04.25</small>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);

export default {
  data() {
    return {
      currentIndex: 1,
    };
  },
  methods: {},
  mounted() {
    const that = this;
  },
  methods: {
    tabFn(i) {
      const that = this;
      that.currentIndex = i;
    },
  },
};
</script>

<style lang="scss" scoped>
section {
  padding: 0.1rem 0;
  border-top: 0.2rem solid #f7f8fa;
  border-bottom: 0.2rem solid #f7f8fa;
  h1 {
    padding: 0 0.5rem;
    font-size: 0.45rem;
    color: #404143;
    line-height: 0.6rem;
    margin: 0.2rem 0;
  }
  p {
    padding: 0.2rem 0.5rem;
    display: flex;
    vertical-align: min;
    span {
      color: #4586c0;
      font-size: 0.4rem;
      text-shadow: 0 0 0;
    }
    img {
      width: 0.25rem;
      margin-right: 0.25rem;
      vertical-align: middle;
    }
  }
}
header {
  video {
    width: 100%;
    display: block;
  }
  h1 {
    padding: 0 0.5rem;
    font-size: 0.45rem;
    color: #404143;
    line-height: 0.6rem;
    margin: 0.2rem 0;
  }
  p {
    color: #c0c4cc;
    font-size: 0.34rem;
    padding: 0 0.5rem 0.3rem;
    span.name {
      color: #404143;
      margin-right: 0.3rem;
    }
  }
}
.tabBox {
  display: flex;
  color: #37383a;

  font-size: 0.45rem;
  .tabName {
    position: relative;
    margin-right: 1rem;
    text-shadow: 0 0 0;
    &.active {
      color: #3a3b3d;
      &::after {
        content: '';
        background: #45a17f;
        width: 0.5rem;
        height: 0.1rem;
        position: absolute;
        bottom: -0.3rem;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
.flex {
  display: flex;
  font-size: 0.45rem;
  text-shadow: 0 0 0;
  li {
    margin: 0 0 0.5rem;
  }
  .no {
    color: #c0c4cc;
    padding-top: 0.1rem;
    flex: 1;
  }
  .course-title {
    flex: 8;
    vertical-align: top;
    font-size: 0.38rem;
    color: #404143;
    line-height: 0.6rem;
    padding-bottom: 0.3rem;
    border-bottom: 1px solid #f3f3f3;
    small {
      display: block;
      color: #c0c4cc;
      font-size: 0.36rem;
      margin-top: 0.1rem;
      font-weight: normal;
    }
  }
}
.courseTabs {
  .van-tab {
    justify-content: flex-start;
  }

  ul li {
    margin: 0.3rem 0;
  }
  padding: 0.5rem;
  .text {
    color: #606266;
    font-size: 0.4rem;
    line-height: 0.8rem;
  }
  .van-tab__text {
    color: #93969c;
    font-size: 0.45rem;
  }
  .van-tab--active {
    span {
      color: #000;
      font-size: 0.48rem;
    }
  }
  .tabContent {
    padding-top: 0.6rem;
  }
  .van-tabs__line {
    background-color: #2b926a;
    transform: translateX(0) translateX(0%) !important;
  }
}
</style>
